import { render, staticRenderFns } from "./BatchCreateForm.vue?vue&type=template&id=ad7650c4"
import script from "./BatchCreateForm.vue?vue&type=script&lang=js"
export * from "./BatchCreateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports